import { render } from "./RepassesPage.vue?vue&type=template&id=f422e3ec&scoped=true"
import script from "./RepassesPage.vue?vue&type=script&lang=js"
export * from "./RepassesPage.vue?vue&type=script&lang=js"

import "./RepassesPage.vue?vue&type=style&index=0&id=f422e3ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f422e3ec"]])

export default __exports__